<template>
    <inertia-head>
        <link
            href="https://cdn.jsdelivr.net/npm/bootstrap@5.2.3/dist/css/bootstrap.min.css"
            rel="stylesheet"
            integrity="sha384-rbsA2VBKQhggwzxH7pPCaAqO46MgnOM80zW1RWuH61DGLwZJEdK2Kadq2F9CUG65"
            crossorigin="anonymous"
        />

        <link
            href="https://fonts.googleapis.com/css2?family=Poppins:wght@100;200;300;400;500;600;700&display=swap"
            rel="stylesheet"
        />
    </inertia-head>

    <main>
        <app-header />

        <slot />
    </main>
</template>

<script>
import AppHeader from "@/Components/Promo/AppHeader";

export default {
    components: {
        AppHeader,
    },
};
</script>

<style>
body {
    font-family: Poppins !important;
}
</style>
